/**
 * SkeletonBone — the atomic building block for all skeleton loaders.
 *
 * Uses --color-skeleton-base / --color-skeleton-highlight CSS variables which
 * are defined with explicit hex values (not part of the inverted gray-scale)
 * in both :root (light) and .dark, ensuring correct contrast in every theme.
 *
 * Usage:
 *   <SkeletonBone className="h-4 w-3/4 rounded" />
 *   <SkeletonBone className="h-8 w-2/3 rounded-lg" />
 */
export default function SkeletonBone({ className = '' }: { className?: string }) {
  return (
    <div
      className={`animate-pulse rounded bg-skeleton-base ${className}`}
      aria-hidden="true"
    />
  );
}
